import { render, staticRenderFns } from "./EstablishmentViewEquipmentTransfers.vue?vue&type=template&id=5efb1420"
import script from "./EstablishmentViewEquipmentTransfers.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewEquipmentTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports